export default "__VITE_ASSET__MQ$fsHtO__"